import React from 'react';

import { css, cx } from 'linaria';
import { theme } from '../../../Theme';
import { styled } from 'linaria/react';

export const checkboxStyle = css`
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  width: 24px;
  height: 24px;
  aspect-ratio: 1/1;
  display: inline-block;
  border-radius: 6px;
  border: 2px solid #8f9892;
  background: transparent;
  cursor: pointer;
  transition: background 0.15s, border-color 0.15s;

  &:checked {
    background: ${theme.colors.accent};
    border-color: ${theme.colors.accent};
    background-image: url('data:image/svg+xml,%3Csvg%20width%3D%2216%22%20height%3D%2212%22%20viewBox%3D%220%200%2016%2012%22%20fill%3D%22none%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%3E%3Cpath%20d%3D%22M1.5%206.5L6.0%2011.0L14.5%202.0%22%20stroke%3D%22white%22%20stroke-width%3D%222.5%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22/%3E%3C/svg%3E');
    background-repeat: no-repeat;
    background-position: center;
    background-size: 11px 10px;
  }

  &:focus-visible {
    outline: 2px solid ${theme.colors.accent};
    outline-offset: 2px;
  }
`;

const ElevateCheckboxLabel = styled('label')`
  display: flex;
  justify-content: space-between;
  gap: 10px;
  align-items: center;
  padding: 1rem;
  font-size: 16px;
  font-style: normal;
  line-height: 24px;

  /* &.checked {
    font-weight: 700;
    background: #eee6de;
  } */
`;

export const ElevateCheckbox = ({
  label,
  count,
  checked,
  onChange,
  checkedClass = 'checked',
  ...rest
}) => {
  const { className, ...restrest } = rest;
  return (
    <ElevateCheckboxLabel
      className={cx(
        'elevate-checkbox-label',
        className,
        checked && checkedClass
      )}
    >
      {label}
      {/* {count && <span>({count})</span>} */}
      <input
        className={checkboxStyle}
        type="checkbox"
        checked={checked}
        onChange={onChange}
        {...restrest}
      />
    </ElevateCheckboxLabel>
  );
};
